import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "card border-0 rounded-0 bg-white performance-box" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "mb-15 d-sm-flex align-items-center justify-content-between" }
const _hoisted_4 = { class: "card-title fw-bold mb-0" }
const _hoisted_5 = {
  id: "performanceChart",
  class: "chart"
}
const _hoisted_6 = { class: "list ps-0 mb-0 list-unstyled" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.nom), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_apexchart, {
          type: "donut",
          height: "270",
          options: _ctx.projectDistributionChart,
          series: _ctx.projects
        }, null, 8, ["options", "series"])
      ]),
      _createElementVNode("ul", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects.length, (i=0) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "d-inline-block text-primary position-relative",
            style: _normalizeStyle(`color:${_ctx.colors[i-1]}`),
            key: i
          }, [
            _createElementVNode("h5", {
              class: "mb-7 fw-black lh-1",
              style: _normalizeStyle(`color:${_ctx.colors[i-1]}`)
            }, [
              _createTextVNode(_toDisplayString(_ctx.projects[i-1]) + " ", 1),
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-muted fs-14 fw-semibold" }, "demande(s)", -1))
            ], 4),
            _createElementVNode("span", {
              class: "d-block fs-13 fw-medium lh-1",
              style: _normalizeStyle(`color:${_ctx.colors[i-1]}`)
            }, _toDisplayString(_ctx.labels[i-1]) + "(s) ", 5)
          ], 4))
        }), 128))
      ])
    ])
  ]))
}